import { ObjectType } from '$app-web/types';

type LangModule = Promise<{ default: ObjectType }>;
type NamespacesKeys = 'pdash' | 'webActivities' | 'rdash' | 'rdashTranslatables';

interface ILanguage {
    code: string;
    locale: string;
    localName: string;
    englishName: string;
    territory: string;
    timezones: Array<string>;
    notLoadedNamespaces: {
        pdash?: LangModule;
        webActivities?: LangModule;
        rdashTranslatables?: LangModule;
        rdash?: LangModule;
    };
}

export class Language implements ILanguage {
    public code;
    public locale;
    public localName;
    public englishName;
    public territory;
    public timezones;
    public notLoadedNamespaces;
    public namespaces: {
        pdash?: ObjectType;
        webActivities?: ObjectType;
        rdashTranslatables?: ObjectType;
        rdash?: ObjectType;
    } = {};

    constructor({ code, locale, localName, englishName, territory, timezones, notLoadedNamespaces }: Partial<ILanguage>) {
        this.code = code ?? '';
        this.locale = locale ?? '';
        this.localName = localName ?? '';
        this.englishName = englishName ?? '';
        this.territory = territory ?? '';
        this.timezones = timezones ?? [];
        this.notLoadedNamespaces = {
            pdash: notLoadedNamespaces?.pdash ?? Promise.resolve({ default: {} }),
            webActivities: notLoadedNamespaces?.webActivities ?? Promise.resolve({ default: {} }),
            rdashTranslatables: notLoadedNamespaces?.rdashTranslatables ?? Promise.resolve({ default: {} }),
            rdash: notLoadedNamespaces?.rdash ?? Promise.resolve({ default: {} }),
        };
    }

    public namespaceHasTranslations(namespace: string): boolean {
        return this.notLoadedNamespaces[namespace as NamespacesKeys] != null;
    }

    public async getNamespaceTranslations(namespace: string) {
        if (this.namespaces[namespace as NamespacesKeys] == null) {
            if (this.notLoadedNamespaces[namespace as NamespacesKeys] != null) {
                const { default: namespaceTranslation } = (await this.notLoadedNamespaces[namespace as NamespacesKeys]) as {
                    default: ObjectType;
                };
                this.namespaces[namespace as NamespacesKeys] = namespaceTranslation;
            } else {
                this.namespaces[namespace as NamespacesKeys] = {};
            }
        }

        return this.namespaces[namespace as NamespacesKeys];
    }
}
